
import { getEnv } from '@tencent/slug-function';
import { closeFullScreen } from '@utils';
import { isMSDKV5, isHarmonyOS } from "@/utils/msdkEnv.js"
const { isIOS, isAndroid, isMSDK, isSlugSDK } = getEnv();
function canGoBack() {
  const params = {};
  params.method = 'canGoBack';
  return prompt(JSON.stringify(params));
}
// scope=backTogame 强制返回游戏
export default function backHandle(scope = '') {
  const { search } = window.location;
  const tokenParams = sessionStorage.getItem('tokenParams');
  const str = tokenParams || search
  let length = (sessionStorage.getItem('historyLength') && Number(sessionStorage.getItem('historyLength')) || 0);
  let maxLength = sessionStorage.getItem('historyMaxLength') && Number(sessionStorage.getItem('historyMaxLength'))
  if (!maxLength || maxLength !== window.history.length) {
    maxLength = window.history.length
    length = maxLength
    sessionStorage.setItem('historyMaxLength', maxLength.toString())
  }
  if (isSlugSDK) {
    if ((isAndroid && window.history.length <= 1) || (isIOS && canGoBack() != '1') || scope === 'backTogame') {
      try {
        // 关闭方法
        const params = {};
        params.method = 'closeWebview';
        prompt(JSON.stringify(params));
      } catch (err) {
        window.Sentry.captureMessage(new Error(`closeslugWebview失败, ${JSON.stringify(err)}`));
      }
      return;
    }
  } else {
    try {
      // 处理msdkv5
      if (isMSDKV5() && ((isIOS && length <= 1) || ((isAndroid || isHarmonyOS()) && length <= 1))) {
        // window.msdkCall('', CloseWebView);
        let CloseWebView = '{"MsdkMethod":"closeWebView"}';
        window.msdkCall('', CloseWebView);
      }
      // 处理msdkv3
      if (/msdk/i.test(navigator.userAgent) || /msdk/i.test(str)) {
        if ((isIOS && window.history.length <= 1) || ((isAndroid || isHarmonyOS()) && window.history.length <= 2) || scope === 'backTogame') {
          window.msdkCloseWebview();
        }
      }
      
      const keepFullScreen = location.search && location.search.toString().indexOf('keepFullScreen=1') > -1;
      if (Boolean(document.referrer) && !keepFullScreen) {
        closeFullScreen();
      }
    } catch (err) {
      Sentry.captureMessage(`msdk方法调用失败失败${err}`);
    }
  }
  window.history.back();
  length = length - 1;
  sessionStorage.setItem('historyLength', length?.toString())
}